<template>
  <div class="main-container">
    <router-view></router-view>
    <!-- Navbar section -->
    <HeaderSoftware />

    <!-- breadcrumb strat -->
    <Breadcrumb>
      <template slot="breadcrumb">
        <div class="breadcrumb_box text-center">
          <h2 class="breadcrumb-title">{{$t('shop')}}</h2>
          <!-- breadcrumb-list start -->
          <ul class="breadcrumb-list">
            <li class="breadcrumb-item">
              <router-link :to="{name:'HomeBranding'}">{{$t('home')}}</router-link>
            </li>
            <li class="breadcrumb-item active">{{$t('shop')}}</li>
            <li class="breadcrumb-item">
              <router-link :to="{name:'checkout'}">{{$t('checkout')}}</router-link>
            </li>
          </ul>
          <!-- breadcrumb-list end -->
        </div>
      </template>
    </Breadcrumb>
    <!-- breadcrumb end -->

    <!-- pricing section -->
    <CurveShape>
      <template v-slot:bgcolor>
        <path
          style="fill: #f6f5f9;
                    stroke-miterlimit:10;"
          d="M3360.5,97.739c-242,0-480-48.375-480-48.375
                        S2647.5,0.5,2400.5,0.5s-480,48.375-480,48.375s-238,48.864-480,48.864s-480-48.375-480-48.375S727.5,0.5,480.5,0.5
                        S0.5,48.875,0.5,48.875V108h1920h1920V48.875C3840.5,48.875,3602.5,97.739,3360.5,97.739z"
        />
      </template>
    </CurveShape>
    <div class="pricing-table-area bg-gray-2 section-space--pb_90" id="pricing">
      <div class="pricing-table-title-area position-relative">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 wow move-up">
              <div class="section-title-wrapper text-center section-space--mb_60">
                <h2
                  class="section-title font-weight--light mb-15 wow move-up"
                >{{ $t('herkesicinuygunfiyatli') }}</h2>
                <span class="section-text wow move-up">{{ $t('egeruygulamadaozelisteginizvarsa') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pricing-table-content-area">
        <div class="container">
          <!-- pricing component -->
          <!-- <PricingOne /> -->

          <div>
            <!-- ITEM VIEW - GRID/LIST -->
            <div class="flex flex-wrap">
              
                
              <span>
              <DxTextBox
                  :show-clear-button="true"
                  :value.sync="sAra"
                  :placeholder="$t('ara')"
                  value-change-event="keyup"
                  width='100%'
                />
              </span>
                <feather-icon
                  icon="GridIcon"
                  @click="currentItemView='item-grid-view'"
                  class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                  :svgClasses="{'text-primary stroke-current': currentItemView == 'item-grid-view'}"
                />
              
                <feather-icon
                  icon="ListIcon"
                  @click="currentItemView='item-list-view'"
                  class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
                  :svgClasses="{'text-primary stroke-current': currentItemView == 'item-list-view'}"
                />
              
            </div>
          </div>
          <br />
          <!-- GRID VIEW -->
          <template v-if="currentItemView == 'item-grid-view'">
            <div class="items-grid-view vx-row match-height">
              <div
                class="vx-col lg:w-1/4 sm:w-1/2 w-full"
                v-for="item in filteredKB"
                :key="item.nStokID"
              >
                <item-grid-view :item="item">
                  <!-- SLOT: ACTION BUTTONS -->
                  <template slot="action-buttons">
                    <div class="flex flex-wrap">
                      <!-- PRIMARY BUTTON: ADD TO WISH LIST
                                                    <div
                                                        class="item-view-primary-action-btn p-3 flex flex-grow items-center justify-center cursor-pointer"
                                                        @click="toggleItemInWishList(item)">
                                                        <feather-icon icon="HeartIcon" :svgClasses="[{'text-danger fill-current' : isInWishList(item.nStokID)}, 'h-4 w-4']" />

                                                        <span class="text-sm font-semibold ml-2">WISHLIST</span>
                      </div>-->

                      <!-- SECONDARY BUTTON: ADD-TO/VIEW-IN CART -->
                      <div
                        class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                        @click="cartButtonClicked(item)"
                      >
                        <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />

                        <span
                          class="text-sm font-semibold ml-2"
                          v-if="isInCart(item.nStokID)"
                        >{{$t('viewincart')}}</span>
                        <span class="text-sm font-semibold ml-2" v-else>{{$t('addtocart')}}</span>
                      </div>
                    </div>
                  </template>
                </item-grid-view>
                
              </div>
            </div>
            
          </template>

          <!-- LIST VIEW -->
          <template v-else>
            <div class="items-list-view mb-base" v-for="item in filteredKB" :key="item.nStokID">
              <item-list-view :item="item">
                <!-- SLOT: ACTION BUTTONS -->
                <template slot="action-buttons">
                  <!-- <div
                                                class="item-view-primary-action-btn p-3 rounded-lg flex flex-grow items-center justify-center cursor-pointer mb-3"
                                                @click="toggleItemInWishList(item)">
                                                <feather-icon icon="HeartIcon" :svgClasses="[{'text-danger fill-current' : isInWishList(item.nStokID)}, 'h-4 w-4']" />
                                                <span class="text-sm font-semibold ml-2">WISHLIST</span>
                  </div>-->
                  <div
                    class="item-view-secondary-action-btn bg-primary p-3 rounded-lg flex flex-grow items-center justify-center text-white cursor-pointer"
                    @click="cartButtonClicked(item)"
                  >
                    <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />

                    <span
                      class="text-sm font-semibold ml-2"
                      v-if="isInCart(item.nStokID)"
                    >{{$t('viewincart')}}</span>
                    <span class="text-sm font-semibold ml-2" v-else>{{$t('addtocart')}}</span>
                  </div>
                </template>
              </item-list-view>
            </div>
            <br>
          </template>

          <!-- <div class="row pricing-table-one">
        <div class="col-md-6 col-xl-3 pricing-table wow move-up" v-for="(pricing,nStokID) in filteredKB" :key="nStokID" :class="{'pricing-table--popular__bg': pricing.bPopular}">
            <div class="pricing-table__inner" :class="{'bg-gradient': pricing.bPopular}">
                <div class="pricing-table__feature-mark" v-if="pricing.bPopular">
                    <span>{{$t('populer')}}</span>
                </div>
                <div class="pricing-table__header">
                    <div class="pricing-table__image">
                        <img :src="require(`@/assets/img/shop/${pricing.nStokID}.png`)" class="img-fluid" :alt="pricing.sAciklama">
                    </div>
                    <h5 class="pricing-table__title">{{ $t(pricing.sAciklama) }}</h5>
                    <div class="pricing-table__price-wrap">
                        <h6 class="currency" v-if="pricing.sDovizCinsi === 'TRL'">&#8378;</h6>
                        <h6 class="currency" v-else-if="pricing.sDovizCinsi === 'USD'">&#36;</h6>
                        <h6 class="price">{{ pricing.lFiyat1 }}</h6>
                        
                    </div>
                </div>
                <div class="pricing-table__body">
                   
                </div>
                <div class="pricing-table__footer"> 
                    <button class="ht-btn ht-btn--outline ht-btn-xs" v-on:click="cartButtonClicked(pricing)" :class="{'btn--white': pricing.bAktif}">Sepete At <span class="btn-icon"><i class="far fa-shopping-cart"></i></span></button>
                    <button class="ht-btn ht-btn--outline ht-btn-xs" v-on:click="showInfo(pricing)" :class="{'btn--white': pricing.bAktif}">Detay     <span class="btn-icon"><i class="far fa-search"></i></span></button>
                </div>
            </div>
        </div>
          </div>-->
          <DxPopup
            :visible.sync="popupVisible"
            :drag-enabled="false"
            :close-on-outside-click="true"
            :show-title="true"
            width="90%"
            height="90%"
            title="detay"
          >
            <div class="header">
              <div class="name-container">
                <div class="name">{{ currentProduct.sAciklama }}</div>
                <div :class="currentProduct.sStar.toLowerCase()" class="type" />
              </div>
              <div class="price-container">
                <h6
                  class="price"
                  v-if="currentProduct.sDovizCinsi === 'USD'"
                >{{ currentProduct.lFiyat1 }}&#36;</h6>
                <h6
                  class="price"
                  v-if="currentProduct.sDovizCinsi === 'TRL'"
                >{{ currentProduct.lFiyat1 }}&#8378;</h6>
              </div>
              <div class="pricing-table__image">
                <b-img
                  :src="require(`@/assets/img/shop/${currentProduct.nStokID}.png`)"
                  center
                  fluid
                  :alt="currentProduct.sAciklama"
                  style="width:350px;height:300px"
                ></b-img>
              </div>
              <DxScrollView id="scrollview" ref="scrollViewWidget">
                <div class="description" v-html="currentProduct.sDetail"></div>
              </DxScrollView>
            </div>
          </DxPopup>

          <!-- <div class="fun-fact-wrapper section-space--pt_60 section-space--pb_60">
            <div class="container">
              <div class="row">
                <div class="col-lg-12">
                  <DxList
                    :data-source="dataSource"
                    :collapsible-groups="true"
                    height="900px"
                    :search-enabled="true"
                    search-mode="contains"
                    searchExpr="sAciklama"
                    selection-mode="single"
                    page-load-mode="scrollBottom"
                    :selected-item-keys="[currentProduct.nStokID]"
                    @selection-changed="listSelectionChanged"
                  >
                    <template #group="{ data: item }">
                      <div class="category">{{ item.sSinifKodu }}</div>
                    </template>
                    <template #item="item">
                      <div class="product">
                        <img :src="require(`@/assets/img/shop/${item.data.nStokID}.png`)" />
                        <div>{{ item.data.sAciklama }}</div>
                        <div class="price">{{ item.data.lFiyat1 }}-{{item.data.sDovizCinsi}}</div>
                      </div>
                    </template>
                  </DxList>
                </div>

                <div class="col-lg-6" id="scroll-to-me">
                  <div class="header">
                    <div class="name-container">
                      <div class="name">{{ currentProduct.sAciklama }}</div>
                      <div :class="currentProduct.sStar.toLowerCase()" class="type" />
                    </div>
                    <div class="price-container">
                      <div class="price">{{ currentProduct.lFiyat1}}-{{currentProduct.sDovizCinsi}}</div>
                    </div>
                    <b-img
                      center
                      :src="require(`@/assets/img/shop/${currentProduct.nStokID}.png`)"
                      style="width:300px;height:300px"
                    />
                    <div v-html="currentProduct.sDetail"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>-->
        </div>
      </div>
    </div>

    <!-- footer section -->
    <FooterMain />

    <!-- offcanvas search component -->
    <OffcanvasSearchBox />

    <!-- off-canvas mobile menu -->
    <OffCanvasMobileMenu />
  </div>
</template>
<script>
import HeaderSoftware from "../components/HeaderSoftware";
import Breadcrumb from "@/components/Breadcrumb";
import FooterMain from "@/components/FooterMain";
import OffcanvasSearchBox from "@/components/OffcanvasSearchBox";
import OffCanvasMobileMenu from "@/components/OffCanvasMobileMenu";
import DxList from "devextreme-vue/list";
import ArrayStore from "devextreme/data/array_store";
import CurveShape from "../components/CurveShape";
// import service from "../data.js";
import { DxTextBox } from "devextreme-vue";
import { DxPopup } from "devextreme-vue/popup";
import { DxScrollView } from "devextreme-vue/scroll-view";
import { stok } from "../stok.js";
// const httpOptions = {
//             headers: new HttpHeaders({
//                 'Access-Control-Allow-Origin': 'http://localhost:8080', // -->Add this line
//                 'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,OPTIONS',
//                 'Access-Control-Allow-Headers': '*',
//                 'Content-Type': 'application/json',
//                 'Accept': 'application/json'
//             })
//         };
import Vue from "vue";
import axios from "axios";

import xml2js from "xml2js";
import fs from "fs";

export default {
  data() {
    return {
      
      currentProduct: stok[0],
      sAra: "",
      tbStok: stok,
      popupVisible: false,
      isFilterSidebarActive: true,
      clickNotClose: true,
      currentItemView: "item-grid-view",
      numericItems: [
        { label: "All" },
        { label: "<= $10", end: 10 },
        { label: "$10 - $100", start: 10, end: 100 },
        { label: "$100 - $500", start: 100, end: 500 },
        { label: ">= $500", start: 500 }
      ],
      algoliaCategories: [
        "hierarchicalCategories.lvl0",
        "hierarchicalCategories.lvl1",
        "hierarchicalCategories.lvl2",
        "hierarchicalCategories.lvl3"
      ],
      dataSource: new ArrayStore({
        key: "nStokID",
        data: stok
      }),
      group: "sSinifKodu",
      searchExpr: ["sKodu", "sAciklama"],
      selectedItemKeys: [],
      selectionMode: "all",
      selectAllMode: "page"
    };
  },
  components: {
    HeaderSoftware,
    Breadcrumb,
    CurveShape,
    FooterMain,
    OffcanvasSearchBox,
    OffCanvasMobileMenu,
    DxList,
    DxTextBox,
    DxPopup,
    DxScrollView,
    ItemGridView: () =>
      import("../components/eCommerce/components/ItemGridView.vue"),
    ItemListView: () =>
      import("../components/eCommerce/components/ItemListView.vue")

  },
 
  computed: {
    filteredKB() {
      return this.tbStok.filter(
        item =>
          item.sAciklama.toLowerCase().includes(this.sAra.toLowerCase()) ||
          item.sDetail.toLowerCase().includes(this.sAra.toLowerCase())
      );
    },

    toValue() {
      return (value, range) => [
        value.min !== null ? value.min : range.min,
        value.max !== null ? value.max : range.max
      ];
    },

    // GRID VIEW
    isInCart() {
      return itemId => this.$store.getters["eCommerce/isInCart"](itemId);
    },
    isInWishList() {
      return itemId => this.$store.getters["eCommerce/isInWishList"](itemId);
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    }
  },

  methods: {
    kurcek(){
    
            var self = this;
            const parseString = require('xml2js').parseString;
           var sconfig = {
             //method: 'GET', // *GET, POST, PUT, DELETE, etc.
    mode: 'no-cors', // no-cors, *cors, same-origin
    cache: 'default', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Access-Control-Allow-Origin':  '*',
      'Access-Control-Allow-Credentials': 'false',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
      //'Access-Control-Allow-Methods': '*',
      //'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
      //'Content-Type': 'application/json,text/txt',
      //'Accept': 'application/json'
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *client
    
                };
            
            var parser = new xml2js.Parser();
            
// fs.readFile('www.tcmb.gov.tr/kurlar/today.xml', function(err, data) {
//     parser.parseString(data, function (err, result) {
//         console.dir(result);
//         console.log('Done');
//     });
// });


axios.get('https://www.tcmb.gov.tr/kurlar/today.xml', sconfig
	
	).then(function (response) {
		console.log('response is : ' + response);
	}).catch(function (error) {
		if (error.response) {
		  console.log(error.response.headers);
		} 
		else if (error.request) {
	      console.log(error.request);
		} 
		else {
		  console.log(error.message);
		}
	console.log(error.config);
});
 
    
      
    },
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isFilterSidebarActive = this.clickNotClose = true;
      } else {
        this.isFilterSidebarActive = this.clickNotClose = true;
      }
    },
    listSelectionChanged(e) {
      console.log(e);
      this.currentProduct = e;
      this.scrollToElement();
    },
    showInfo(e) {
      console.log(e);
      this.currentProduct = e;
      this.popupVisible = true;
    },
    scrollToElement() {
      const el = this.$el.getElementsByClassName("scroll-to-me")[0];

      if (el) {
        el.scrollIntoView();
      }
    },
    // GRID VIEW - ACTIONS
    toggleFilterSidebar() {
      if (this.clickNotClose) return;
      this.isFilterSidebarActive = !this.isFilterSidebarActive;
    },
    toggleItemInWishList(item) {
      this.$store.dispatch("eCommerce/toggleItemInWishList", item);
    },
    additemInCart(item) {
      this.$store.dispatch("eCommerce/additemInCart", item);
    },
    cartButtonClicked(item) {
      this.isInCart(item.nStokID)
        ? this.$router.push("/checkout").catch(() => {})
        : this.additemInCart(item);
    }
  },
  created() {
   
    this.setSidebarWidth();
    //this.kurcek();
  }
};
</script>
<style scoped>
.product {
  height: 65px;
}

.product > img {
  height: 100%;
  width: 65px;
  float: left;
}

.product > div {
  padding-left: 10px;
  vertical-align: top;
  line-height: 65px;
  font-size: 15px;
  float: left;
}

.product > div.price {
  float: right;
  font-size: 18px;
}

.left {
  float: left;
  width: 330px;
  height: 470px;
  padding: 20px;
  background: rgba(191, 191, 191, 0.15);
  margin-right: 30px;
}

.right {
  overflow: hidden;
}

.left .list .dx-list-group-header {
  color: #f05b41;
  font-weight: normal;
  font-size: 18px;
}

.left .list .hotel {
  float: left;
}

.left .list .hotel .name {
  font-weight: bold;
}

.right .header {
  height: 70px;
}

.right .header .name-container {
  float: left;
}

.right .header .name {
  font-size: 30px;
  font-weight: bold;
}

.right .header .price-container {
  padding-top: 27px;
}

.right .name-container .type {
  margin-top: 0;
}

.right .tile {
  margin: 0 -12px 0 -12px;
}

.right .tile-image {
  height: 100%;
  width: 100%;
  background-size: cover;
}

.right .address {
  padding-top: 30px;
  font-size: 18px;
  opacity: 0.7;
}

.right .description {
  margin: 10px 0;
}

.type {
  margin: 3px 0 5px 0;
  height: 14px;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%2218px%22%20height%3D%2214px%22%20%3E%3Cpolyline%20fill%3D%22%23F05B41%22%20points%3D%227.5%2C0%209.972%2C4.399%2014.999%2C5.348%2011.5%2C9.015%2012.135%2C14%207.5%2C11.866%202.865%2C14%203.5%2C9.015%200.001%2C5.348%205.028%2C4.399%207.5%2C0%20%22%2F%3E%3C%2Fsvg%3E");
  background-size: 18px 14px;
}

.type.gold {
  width: 54px;
}

.type.platinum {
  width: 72px;
}

.type.diamond {
  width: 90px;
}

.price-container {
  float: right;
  padding-top: 13px;
}

.price-container > div {
  display: inline-block;
}

.price-container .price {
  font-size: 25px;
}

.price-container .caption {
  font-size: 11px;
  line-height: 12px;
  padding-left: 2px;
  opacity: 0.7;
}

/* .dx-list .dx-list-item {
  width: "25%";
  border: "0px";
  float: "left";
} */
</style>
<style lang="scss">
#algolia-instant-search-demo {
  .algolia-header {
    .algolia-filters-label {
      width: calc(260px + 2.4rem);
    }
  }

  #algolia-content-container {
    .vs-sidebar {
      position: relative;
      float: left;
    }
  }

  .algolia-search-input-right-aligned-icon {
    padding: 1rem 1.5rem;
  }

  .algolia-price-slider {
    min-width: unset;
  }

  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
    min-width: 50%;
  }

  .item-view-secondary-action-btn {
    min-width: 50%;
  }
}

.theme-dark {
  #algolia-instant-search-demo {
    #algolia-content-container {
      .vs-sidebar {
        background-color: #10163a;
      }
    }
  }
}

@media (min-width: 992px) {
  .vs-sidebar-rounded {
    .vs-sidebar {
      border-radius: 0.5rem;
    }

    .vs-sidebar--items {
      border-radius: 0.5rem;
    }
  }
}

@media (max-width: 992px) {
  #algolia-content-container {
    .vs-sidebar {
      position: absolute !important;
      float: none !important;
    }
  }
}
</style>
